import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function TagIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 17.5} height={height || 14} viewBox="0 0 17.5 14">
      <path
        data-name="Path 10028"
        d="M13.616-6.072l-5.794-5.794a1.508 1.508 0 00-.928-.384H1.312A1.312 1.312 0 000-10.937v5.581a1.508 1.508 0 00.384.928l5.794 5.794a1.313 1.313 0 001.856 0l5.581-5.581a1.313 1.313 0 00.001-1.857zM3.062-7.875A1.312 1.312 0 011.75-9.187 1.312 1.312 0 013.062-10.5a1.312 1.312 0 011.313 1.313 1.312 1.312 0 01-1.313 1.312zm14.054 3.659a1.313 1.313 0 000-1.856l-5.794-5.794a1.508 1.508 0 00-.928-.384H9.062l5.366 5.366a2.445 2.445 0 01.721 1.74 2.445 2.445 0 01-.721 1.74l-4.76 4.76.01.01a1.313 1.313 0 001.856 0z"
        transform="translate(0 12.25)"
        fill={color || "#bbb"}
      />
    </svg>
  );
}
